import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
// import { InputContainer } from ".../../MoveOut.styled";
import cc from "../../assets/ccIcon.svg";
import { Label } from "../../screens/complaint/Complaint.styled";
import cvv from "../../assets/cvv.svg";
import CloseIcon from "../../assets/CloseIcon.svg";
import ThanksIcon from "../../assets/thanks.svg";
import styled from "styled-components";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import OtpInput from "react18-input-otp";

import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";

const InputContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: #edf4f6;
    border: 1px solid #b6bfdc;
    margin: 0 0.5rem;
  }
`;

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  //   onVerify:any,
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;
  delData: () => void;
  delLoader?: Boolean
}

const DelModal = ({ onClose, delData, delLoader }: Props) => {
 

  return (
    <div
    style={{
      zIndex: 9999,
      backgroundColor: General.contrast.contrastColor
      ? General.contrast.contrastColor
      : '#fff',
      overflow: "auto",
      width: General?.isLargeScreen ? "50%" : "100%",
      margin: "auto",
      direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr",
    }}
  >
    <div
      style={{

        background: General.contrast.contrastBackground
          ? General.contrast.contrastBackground
          : General?.ColorAss,
        padding: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <h1 id="modal-title" style={{
        color: General.contrast.contrastColor
          ? General.contrast.contrastColor
          : '#fff', margin: 0
      }}>
        {General?.codeLabels['cm_del']?.label ? General?.codeLabels['cm_del']?.label : "Delete"}
      </h1>
      <span
        style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff', fontSize: 32, cursor: "pointer"
        }}
        onClick={onClose}
      >
        x
      </span>
    </div>

    <TabContainer style={{ padding: '20px',
    background: General.contrast.contrastColor
    ? General.contrast.contrastColor
    : "#fff",
    width:'100%',
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    }}>
      {" "}
      <Label style={{
        fontWeight: "800", fontSize: '15px', 
        color: General.contrast.contrastBackground
          ? General.contrast.contrastBackground
          : General.ColorAss,
          
      }}>
        {General?.codeLabels['cm_confirm_del']?.label ? General?.codeLabels['cm_confirm_del']?.label : "Are You Sure to Delete the Bank Details?"}
      </Label>

      <hr style={{ gridColumn: "1 / span 2", width: "100%" }} />

       <TabContainer
        style={{
          padding: "0.3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}
      >

        <ButtonsContainer
          style={{ display: "flex", gap: "12px", width: "fit-content", paddingBottom: "1rem" }}
        >
          <ButtonSecondary
            style={{ 
              width: "45%", 
              padding: "auto",
              fontSize:`${General.accessibility.fontSize}rem`,
              background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "white",
              borderColor: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
            }}
            onClick={onClose}
          >
            {General?.codeLabels["cm_usepassloginpagecancel"]?.label !== undefined ? General?.codeLabels["cm_usepassloginpagecancel"]?.label : "CANCEL"}

          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: "45%",
              padding: "auto",
              color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground:"#fff",
              background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor :General?.ColorAss,
              border:"none",
              whiteSpace: "nowrap",fontSize:`${General.accessibility.fontSize}rem`
            }}
            onClick={delData}
          >
            {General?.codeLabels["cm_delete"]?.label !== undefined ? General?.codeLabels["cm_delete"]?.label : "DELETE"}
         </ButtonSecondary>
        </ButtonsContainer>
      </TabContainer>
    </TabContainer>


  </div>
  );
};

export default observer(DelModal);
